module.exports = __webpack_public_path__ + "img/20200709_160331.70ed3748.jpg";